import React, { useRef, useState, useEffect } from 'react'
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import "../styleCV/CV02.css"
import { Link } from 'react-router-dom';

const CV02 = () => {

    document.body.style.background = "white";

    const [Image, setImage] = useState()
    const [fname, setfname] = useState()
    const [lname, setlname] = useState()
    const [jobTitle, setjobTitle] = useState()
    const [phone, setphone] = useState()
    const [email, setemail] = useState()

    //address info
    const [street, setstreet] = useState()
    const [city, setcity] = useState()
    const [state, setstate] = useState()
    const [country, setcountry] = useState()
    const [postcode, setpostcode] = useState()

    //educational details 
    const [educationHTML, seteducationHTML] = useState()

    //summary
    const [CVDescription, setCVDescription] = useState()

    //skills 
    const [CVSkills, setCVSkills] = useState()

    //Experience
    const [experienceHTML, setexperienceHTML] = useState()

    //Project info
    // const [projectInfoHTML, setprojectInfoHTML] = useState()
    
    //achievements 
    const [CVAchievements, setCVAchievements] = useState()
    
    //languages
    const [langs, setLangs] = useState()

    useEffect(() => {
        //image photo 
        setImage(localStorage.getItem("profilePhoto"));

        //fetch objs from storage 
        const personalInfo = JSON.parse(localStorage.getItem("personalDetails"))
        //personal info
        if (personalInfo !== null) {
            setfname(personalInfo.firstname)
            setlname(personalInfo.lastname)
            setjobTitle(personalInfo.jobtitle)

            //contact info
            setphone(personalInfo.phone)
            setemail(personalInfo.email)

            //address info
            setstreet(personalInfo.address)
            setcity(personalInfo.city)
            setstate(personalInfo.state)
            setcountry(personalInfo.country)
            setpostcode(personalInfo.postcode)
        }

        //educational info
        const education = JSON.parse(localStorage.getItem("Education"));
        populateEducation(education)

        //summary
        setCVDescription(localStorage.getItem("CVDescription"));
        
        //languages
        setLangs(localStorage.getItem("cvlangs"));

        //Experience
        const experience = JSON.parse(localStorage.getItem("ProfessionalExperience"))
        populateExperience(experience);

        //skills
        const skills = JSON.parse(localStorage.getItem('skills'));
        populateSkills(skills)

        //achievements
        const achievements = JSON.parse(localStorage.getItem('achievements'));
        populateAchievements(achievements)
        
        //project Info
        // const projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
        // populateProject(projectInfo);
    }, [])
    

    const populateAchievements = (achievements) => {
        if (achievements[0].achievements !== "") {
            setCVAchievements(
                <>
                    <div className="boxp02" id="Achievementsp02">
                        <h3 className="titlep02" id="Achievementstitlep02">Achievements</h3>
                        <ul className='achievementlistp02'>

                            {achievements.map((ach, index) => (

                                <li className="listitemp02">{ach.achievements}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateSkills = (skills) => {
        if (skills[0].skill !== "") {
            setCVSkills(
                <>
                    <div className="boxp02" id="Skillsp02">
                        <h3 className="titlep02" id="Skillstitlep02">Skills</h3>
                        <ul className='skilllistp02'>

                            {skills.map((sk, index) => (

                                <li className="listitemp02">{sk.skill}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateExperience = (experience) => {
        if (experience[0].WorkSummary !== "" || experience[0].StartDate !== "" || experience[0].PositionTitle !== "" || experience[0].EndDate !== "" || experience[0].ComponyName !== "") {
            setexperienceHTML(
                <>
                    <h3 className="titlep02" id="expertitlep02">Experience</h3>
                    {experience.map((exp, index) => (
                        <div key={index} className="experienceblock">
                            <div>
                                <div className="jobtitlep02">
                                    <label>{exp.PositionTitle}</label>
                                </div>
                                <div className='companynamep02'>
                                    <span>{exp.CompanyName}</span>
                                </div>
                                <div className="durationp02">
                                    <span className="startdatep02">{exp.StartDate}</span><span>-</span><span className="lastdatep02">{exp.EndDate}</span>
                                </div>
                                <div className="descriptionp02">{exp.WorkSummary}</div>
                            </div>
                        </div>
                    ))}
                </>
            )
        }
    }

    const populateEducation = (education) => {
        if (education[0].schname !== "" || education[0].schloc !== "" || education[0].field !== "" || education[0].edustrdate !== "" || education[0].eduendate !== "" || education[0].deg !== "") {
            seteducationHTML(
                <>
                    <h3 className="titlep02" id="educationtitlep02" >Education</h3>
                    <ul class="leftsidelist1p02">
                        {education.map((edu, index) => (
                            <li>
                                <div>
                                    <h4><span>{edu.deg}</span> in <span>{edu.field}</span></h4>
                                </div>
                                <div><span>{edu.edustrdate}</span> - <span>{edu.eduendate}</span></div>
                                <div>{edu.schname}</div>
                                <div>{edu.schloc}</div>
                            </li>

                        ))}
                    </ul>
                </>
            )
        }
    }

    // const populateProject = (projectInfo) => {
    //     if (projectInfo[0].projectTitle !== "" || projectInfo[0].projectDesc !== "") {
    //         setprojectInfoHTML(
    //             <>
    //                 <div className="boxp02" id="projectp02">
    //                     <h3 className="titlep02" id="protitp02" >Project</h3>
    //                     <div className="projectsListp02">
    //                         {projectInfo.map((prj, index) => (
    //                             <div className="Pro1p02">
    //                                 <div className="protitlep02">{prj.projectTitle}</div>
    //                                 <div className="prodescripp02">{prj.projectDesc}</div>
    //                             </div>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </>
    //         )
    //     }
    // }

    const table = document.getElementById('CVp02');

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    const downloadImage = () => {
        html2canvas(table).then(function (canvas) {
            const link = document.createElement('a');
            link.download = 'business.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        });
    }


    return (<>
        <div className="containerp02">

            <div className="CVp02" ref={componentRef} id="CVp02">

                <div className='upperpartp02'>
                    {/* <div className='imgnameclass'> */}
                    <div className='imgcontainerp02'>
                        <img className='userPhotop02' src={Image} alt="" />
                    </div>

                    <div className='fullnameAndPostp02'>

                        <div className='namep02'>
                            <span className='fullNamep02'><span>{fname}</span>&nbsp;<span>{lname}</span></span>
                        </div>

                        <div className='positionp02'>
                            <span className='posp02'>{jobTitle}</span>
                        </div>
                    </div>

                    {/* </div> */}

                    <div className='boxp02' id="contactinfop02" >
                        <h3 className="titlep02" id='conttitle'>Contact</h3>

                        <ul classname="leftsidelistp02">
                            <li>
                                <span className="iconp02" id="icon1p02"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <span className="text1p02">{phone}</span>
                            </li>
                            <li className='list2p02'>
                                <span className="iconp02" id="icon2p02"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                                <span className="text2p02">{email}</span>
                            </li>
                            {/* <li className='list3itemp02'>
                <span className="iconp02" id="icon3p02"><i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                <span className="text3p02">www.linked.com </span>
              </li> */}
                            <li className='list4p02'>
                                <span className="iconp02" id="icon4p02"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div className='addresp02'>
                                    <span className="text4p02" ><span>{street}</span>, <span>{city}</span><span>, </span><span>{state}</span>, <span>{country}</span>&nbsp;(<span>{postcode}</span>)</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="lowerpartp02">

                    <div className="leftsidep02">
                        <div className='boxp02' id="Educationp02">
                            {/* <h3 className="titlep02" id="educationtitlep02" >Education</h3> */}
                            {/* <ul class="leftsidelist1p02">
                                <li>
                                    <div>
                                        <h4>Masters degree in computer science</h4>
                                    </div>
                                    <div>2021-2023</div>
                                    <div>d.y.patil university</div>
                                    <div>123 Anywhere st, Any city</div>
                                </li>
                                 
                            </ul> */}
                            {educationHTML}
                        </div>

                        {/* <div className="boxp02" id="Skillsp02">
                            <h3 className="titlep02" id="Skillstitlep02">Skills</h3>
                            <ul className='skilllistp02'>
                                <li className="listitemp02">problem solving</li>
                            </ul>
                        </div> */}
                        {CVSkills}
                        
                        {CVAchievements}
                        
                        <div className="boxp02" id="langboxp02" >
                            <h3 className="titlep02" id="langtitlep02">Languages</h3>
                            <div id="langp02" >{langs}</div>
                        </div>  


                    </div>

                    <div className="rightsidep02">
                        <div className="boxp02" id="summaryboxp02" >
                            <h3 className="titlep02" id="summarytitlep02">Summary</h3>
                            <div id="summaryp02" >{CVDescription}</div>
                        </div>

                        <div className="boxp02" id="experiencep02" >
                            {/* <h3 className="titlep02" id="expertitlep02">Experience</h3> */}
                            {/* <div className="experienceblock">
                                <div className="jobtitlep02">
                                    <label>Full stack developer</label>
                                </div>
                                <div className='companynamep02'>
                                    <span>infosys | </span><span>123,pune shivaji road</span>
                                </div>
                                <div className="durationp02">
                                    <span className="startdatep02">2021</span><span>-</span><span className="lastdatep02">present</span>
                                </div>
                                <div className="descriptionp02">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cumque fugit praesentium quisquam neque adipisci quidem placeat similique molestias? Velit.</div>
                            </div> */}
                            {experienceHTML}
                        </div>

                        {/* project info */}
                        {/* {projectInfoHTML} */}

                        {/* <div className="boxp02" id="projectp02"> */}
                        {/* <h3 className="titlep02" id="protitp02" >Project</h3> */}
                        {/* <div className="projectsListp02">
                                <div className="Pro1p02">
                                    <div className="protitlep02">data structure library</div>
                                    <div className="prodescripp02">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, vero?</div>
                                </div>

                                <div className="pro2p02">
                                    <div className='protitlep02'>chatbot</div>
                                    <div className="prodescripp02">Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur repellendus incidunt fuga impedit veniam.</div>
                                </div>
                            </div> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
            {/* buttons to print the document */}
            <div className="container" style={{ "width": "100%", "display": "flex", "flexDirection": "row", "alignItems": "center", "justifyContent": "center", marginTop: "40px", "gap": "30px" }}>


                <Link to="/CVform1" k><button id='eidtForm' type="button" className="btn btn-success business02-btn">EDIT FORM</button></Link>
                <button id='mybtn' onClick={handlePrint} type="button" className="btn btn-success business02-btn">Download PDF</button>
                <button onClick={downloadImage} type="button" className="btn btn-success business02-btn">Download Image</button>

            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "kanit",
                    marginBottom: "20px",
                    marginTop: "30px"

                }}
            >
                <Link
                    to="/"
                    class="btn btn-outline-danger"
                    style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}
                >
                    Back
                </Link>

                <Link to="/cv03"

                    class="btn btn-outline-success"
                    style={{ width: "180px", fontSize: "18px" }}
                >
                    Next
                </Link>

{/* <Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Edit form . .&nbsp;&nbsp;&nbsp;&nbsp;</Link>

<button id="mybtn" onClick={handlePrint} type="button" className="btn btn-outline-success mr-2">
  Download PDF
</button>
<button onClick={downloadImage} type="button" className="btn btn-outline-success" >
  Download Image
</button>

<Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;</Link> */}

            </div>

        </div >

    </>
    )
}

export default CV02